export default {
    bindings: {
        ngModel: '=',
        ngRequired: '=',
        inputLabel: '@',
        mHelp: '@',
    },
    require: {
        ngModelCtrl: "ngModel",
        form: '^form'
    },
    template: ['$element', '$attrs', AppEditCbTemplateBuilder],
    controller: ['$element', AppEditCbCtrl],
    controllerAs: 'vm'
};
function AppEditCbCtrl($element) {
    var vm = this;
    this.$onInit = function () {
        vm.isRequired = function () {
            return $element.find('input').attr('required') ? true : false;
        };
    };
}
function AppEditCbTemplateBuilder($element, $attrs) {
    var inputId = ('fld' + $attrs.ngModel + Math.random()).replace(/\W+/g, '');
    var inputLabel = $attrs.inputLabel || inputId;
    var htmlInputType = 'text';
    var inputExtra = '';
    var required = '';
    if ($attrs.required !== undefined) {
        required = ' required="required"';
    }
    if ($attrs.ngRequired) {
        required = required.concat(' ng-required="vm.ngRequired"');
    }
    var html = [];
    html.push('<div class="form-group" ng-class="{ \'has-error\' : vm.form.INPUTID.$invalid }">');
    html.push('<div class="col-sm-8 col-sm-offset-4 col-md-offset-3">');
    html.push('<div class="checkbox">');
    html.push('<label for="INPUTID">');
    html.push('<input id="INPUTID" name="INPUTID" ng-model="vm.ngModel" type="checkbox" ' + required + ' />');
    html.push('{{::vm.inputLabel}}');
    html.push('</label>');
    html.push('<div ng-messages="vm.form.INPUTID.$error" role="alert">');
    html.push('<p ng-message="required" class="help-block bg-danger" translate>pakollinen_tieto</p>');
    html.push('</div>');
    html.push('<p ng-if="::vm.mHelp" class="help-block">{{::vm.mHelp}}</p>');
    html.push('</div>');
    html.push('</div>');
    html.push('</div>');
    var result = html.join("\n").replace(/INPUTID/g, inputId);
    return result;
}
